import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActionsPluginService } from './actions.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../modal/modal.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'actions-edit',
  templateUrl: './actions-edit.component.html',
  standalone: false
})
export class ActionsEditPageComponent extends BaseModalPageComponent implements OnInit, OnDestroy {
  plugin: any;
  editForm: UntypedFormGroup;
  yesNoOptions: any[];
  inspectionId: string;
  pointId: string;
  pluginId: string;
  public processing = false;
  private currentControlName: string;

  private sub = new Subscription();

  @ViewChild('yesNoModal', { static: true }) yesNoModal: ModalComponent;
  @ViewChild('menuModal', { static: true }) menuModal: ModalComponent;
  @ViewChild('pluginDeleteConfirm', { static: true }) pluginDeleteConfirm: any;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: ActionsPluginService
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService.updateActions(this.inspectionId, this.pointId, this.pluginId, model).subscribe((el) => {
      this.processing = false;
      this.goToBack();
    });
  }

  public onClose(e: any) {
    this.editForm.markAsTouched();
  }

  public openYesNoSelector() {
    const control = this.editForm.controls.ActionNeeded;
    this.openSelector(this.yesNoModal, this.yesNoOptions, control.value);
  }

  public selectYesNoMenu(item: any) {
    const control = this.editForm.controls.ActionNeeded;
    const selectedIndex = control.value === item.selectedIndex ? '' : item.selectedIndex;
    control.setValue(selectedIndex);
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
    }
  }

  public deletePlugin() {
    this.pluginService.deletePlugin(this.inspectionId, this.pointId, this.pluginId).subscribe(
      (data) => {
        this.goToBack();
      },
      (error) => {
        console.log('error deleting plugin', error);
      }
    );
  }

  private openDeleteConfirm() {
    this.pluginDeleteConfirm.open();
  }

  private gotoEditJsonPage() {
    this.router.navigate([`/inspections/${this.inspectionId}/points/${this.pointId}/plugins/${this.pluginId}/editJson`]);
  }

  private gotoEditPage() {
    this.router.navigate([`/inspections/${this.inspectionId}/points/${this.pointId}/plugins/${this.pluginId}/edit`]);
  }

  private initRoute() {
    this.sub.add(
      this.activatedRoute.params.subscribe((params: Params) => {
        const inspectionId = params['inspectionId'];
        const pointId = params['pointId'];
        const pluginId = params['pluginId'];

        this.inspectionId = inspectionId;
        this.pointId = pointId;
        this.pluginId = pluginId;

        this.initData();
      })
    );
  }

  private initData() {
    this.yesNoOptions = this.pluginService.getYesNoOptions();
    this.pluginService.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
    });
  }

  private initForm() {
    this.editForm = new UntypedFormGroup({
      ActionNeeded: new UntypedFormControl(this.plugin.config.Actions.ActionNeeded),
      Comment: new UntypedFormControl(this.plugin.config.Actions.Comment),
      OEMSpeed: new UntypedFormControl(this.plugin.config.Actions.OEMSpeed),
      TOPSpeed: new UntypedFormControl(this.plugin.config.Actions.TOPSpeed),
      AdditionalText: new UntypedFormControl(this.plugin.config.Actions.AdditionalText)
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
